import styled from "styled-components";
import {JackpotBetWidgetGamesListContainerDefaultBox} from "./jackpot-bet-widget-games-list-container.default.box";

export const JackpotBetWidgetGamesListContainerMRGBox = styled(JackpotBetWidgetGamesListContainerDefaultBox)`
  background: #015536;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  padding-bottom: 1rem;
  padding-top: 1rem;
`;
